import React from "react";
import { useLottie } from "lottie-react";
import PropTypes from "prop-types";

const getSize = (size) => {
    if (size === "small") {
        return {
            height: "150px",
            width: "auto",
        };
    }
    return {
        height: "250px",
        width: "auto",
    };
};

const Lotties = ({ file, size, loop = true }) => {
    const options = {
        animationData: file,
        loop: loop,
    };

    const { View } = useLottie(options, getSize(size));

    return <>{View}</>;
};

Lotties.propTypes = {
    file: PropTypes.object,
    size: PropTypes.string,
    loop: PropTypes.bool,
};

export default Lotties;
